import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'antd'

import AddSeason from '../../dataDisplay/AddSeason'
import './../../ui.style.scss'

class AddSeasonModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      disable: true
    }
  }

  resetState = () => {
    const state = {
      newTitle: undefined,
      newMailId: undefined,
      disable: true
    }
    this.setState({ ...state })
  }

  render () {
    const { visible, handleCancel, title, okText, project } = this.props
    return (

      <Modal
        className='general-modal add-season-modal'
        visible={visible}
        closable={false}
        title={title}
        // okButtonProps={{ disabled: !(newTitle), loading: loading }}
        // onOk={this.handleSubmit}
        onCancel={handleCancel}
        okText={okText}
        cancelText='Back'
        // afterClose={this.resetState}
        width='650px'
        centered
        destroyOnClose
        maskClosable={false}
      >
        <AddSeason project={project} />
      </Modal>
    )
  }
}

AddSeasonModal.propTypes = {
  /** visible action of AddSeasonModal. */
  visible: PropTypes.bool,
  /** handleCancel action of AddSeasonModal. */
  handleCancel: PropTypes.func
}

AddSeasonModal.defaultProps = {
}

export default AddSeasonModal
